
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-core
* (C) Copyright IBM Corp. 2018, 2020
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'generalInfo': 'Geral',
	'widgetId': 'ID de Widget',
	'widgetType': 'Tipo de widget',
	'serviceability': 'Facilidade de Serviços',
	'copyButton': 'Copiar',
	'closeButton': 'Fechar',
	'specification': 'Especificação',
	'viewSpecification': 'Visualizar especificação'
});
